import { css } from '@emotion/react'
import geladaSemiBoldFont from '@/assets/fonts/GeladaRC3-SemiBold.otf'
import geladaBlackFont from '@/assets/fonts/GeladaRC3-Black.otf'
import {
  FLOATING_CHAT_LAUNCHER_SELECTOR,
  FLOATING_CHAT_LAUNCHER_STACK_SELECTORS,
  FLOATING_SCROLL_PADDING_TARGET_SELECTOR,
  FLOATING_SURVEY_ROOT_SELECTOR,
  MOBILE_SURVEY_SCROLL_PADDING_PX,
  FLOATING_BOTTOM_BAR_HEIGHT_PX,
  FLOATING_CORNER_LAUNCHER_BOTTOM_OFFSET_PX,
  FLOATING_CORNER_LAUNCHER_HORIZONTAL_OFFSET_PX,
  buildCornerLauncherStackCss,
} from '@/styles/floatingWidgetsLayout'

const cornerLauncherStackCss = buildCornerLauncherStackCss({
  surveySelector: FLOATING_SURVEY_ROOT_SELECTOR,
  chatSelector: FLOATING_CHAT_LAUNCHER_SELECTOR,
  launcherSelectors: FLOATING_CHAT_LAUNCHER_STACK_SELECTORS,
  bottomBarHeightPx: FLOATING_BOTTOM_BAR_HEIGHT_PX,
  cornerBottomOffsetPx: FLOATING_CORNER_LAUNCHER_BOTTOM_OFFSET_PX,
  cornerHorizontalOffsetPx: FLOATING_CORNER_LAUNCHER_HORIZONTAL_OFFSET_PX,
})

export const GlobalStyles = css`
  @font-face {
    font-family: 'Gelada-SemiBold';
    src: url('${geladaSemiBoldFont}') format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Gelada-Black';
    src: url('${geladaBlackFont}') format('opentype');
    font-display: swap;
  }

  :root {
    --font-gelada-semi-bold: 'Gelada-SemiBold', sans-serif;
    --font-gelada-black: 'Gelada-Black', sans-serif;
  }

  * {
    margin: 0;
    padding: 0;
    border: 0;
  }

  html {
    height: 100%;
  }

  body {
    height: 100%;
    background-color: var(--foundation-bg-primary-weak);
  }

  .super-classe {
    color: #d246d9;
  }

  #app,
  #view-consumer-phone-modals,
  #order-details-modal,
  #note-print,
  #scheduled-orders-print-container,
  #print-restitution,
  #cash-balance-print {
    font:
      16px 'Roboto',
      Roboto,
      sans-serif;
    line-height: 22px;
    margin: 0 auto;
    position: relative;
  }

  .hidden-page {
    display: none;
  }

  .overlay {
    z-index: 2147483603;
  }

  /* Survey bar only — corner launcher floats; when both exist it stacks up via rules below. */
  body:has(${FLOATING_SURVEY_ROOT_SELECTOR})
    ${FLOATING_SCROLL_PADDING_TARGET_SELECTOR} {
    padding-bottom: calc(
      ${MOBILE_SURVEY_SCROLL_PADDING_PX}px + env(safe-area-inset-bottom, 0px)
    );
  }

  /* Never stack corner launchers on top of the bottom survey bar. */
  ${cornerLauncherStackCss}

  @media print {
    .hidden-page {
      display: block !important;
    }

    .hidden-print,
    #spr-live-chat-app,
    #order-details-modal,
    div[data-testid='survey-root'] {
      display: none !important;
    }

    #app {
      height: auto;
    }

    #app :not(.hidden-page) {
      display: none !important;
    }

    /* Keep body-level portals used for print and hide external widgets. */
    body
      > *:not(#note-print):not(#scheduled-orders-print-container):not(
        #print-restitution
      ):not(#cash-balance-print) {
      display: none !important;
    }
  }

  table {
    border-collapse: collapse;
  }

  @page {
    margin: 0;
  }
`
